module.exports = __webpack_public_path__ + "img/tablet-fill.85eefdbe.svg";